import { getCreateWith } from './createWith';
import { exportCanvasPng } from './exportCanvas';

/**
 * Exports the 1:1 display canvas as a PNG, hands it to the app (`post`) and
 * closes the editor. The app then asks whether to publish. The exported image
 * is always the original pixel size; upscaling only happens for device saves.
 */
export async function saveOnlineAndClose(): Promise<void> {
	const createWith = getCreateWith();
	if (!createWith) throw new Error('The app bridge is not available.');
	await createWith.post(exportCanvasPng());
	createWith.close();
}
